export default __webpack_public_path__ + "static/meta-171c83a541ae460eed1edf7d6c5c6801.png";